import StatusInfo from "manager/cmath/status/info"


export function offcanvasReducer(state, action) {

    return(
        <StatusInfo
            {...action}
        ></StatusInfo>
    )
}